(function CruiseSheets($, Adzuki)
{
	"use strict";

	var $cabins_pricing        = $('.price'),
		$sheet                 = $('.sheets.cruise'),
		cs_id                  = $sheet.data('cruise-sheet-id'),
		allow_excursions       = $sheet.data('allow-excursions'),
		pricing_method         = $sheet.data('pricing-method'),
		expiration_seconds     = $sheet.data('pricing-expiration-seconds'),
		cruise_component       = $sheet.data('cruise-component-id'),
		cached_pricing_expired = parseInt($sheet.data('pricing-cache-expired')),
		$print_icon            = $(Adzuki.FaIcon.getIconSelectorName('print')),
		preview                = $sheet.data('preview');

	$(document).ready(function documentReady()
	{
		var cruiseSheetPages = ['/CruiseSheets/view'];

		Adzuki.onload(cruiseSheetPages, function onload()
		{
			var icon                        = $('.excursions-tab i'),
			    panel                       = $('#excursions'),
			    expiration_milliseconds_ago = getExpirationTime(),
			    last_refresh;

			// checking if we need to refresh live pricing.
			// only if econnect and not associated with an option booking
			if ( (pricing_method === 'econnect') && (cruise_component.length === 0) ) {

				console.log('======================================================');
				console.log('initial page load');

				if (cached_pricing_expired === 1) {
					console.log('refresh pricing');
					retrievePricing(cs_id, false);
				} else {
					console.log('DO NOT refresh pricing');
				}

				// on an interval, check if the pricing needs to be refreshed.  If the client happened to load the page 30 seconds before the cache expired,
				// we probably want to refresh the pricing to get that fresh fresh.  Or if the client opened the page, walked away to deuce, and came back an hour later,
				// we want to show fresh fresh as well
				window.setInterval(function refreshCheck() {
					last_refresh                = getLastRefreshedMilliseconds();
					expiration_milliseconds_ago = getExpirationTime();

					// if we need to debug, uncomment these lines
					console.log('======================================================');
					console.log('interval check');
					// console.log('last pricing refresh = ' + last_refresh);
					// console.log('expiration datetime = ' + expiration_milliseconds_ago);

					if (last_refresh < expiration_milliseconds_ago) {
						// uncomment for debugging purposes
						console.log('refresh pricing');
						retrievePricing(cs_id, true);
					} else {
						console.log('DO NOT refresh pricing');
					}
				}, 60000); // check every 60 seconds
			}

			// only load excursions via ajax if agent has allowed excursions to appear
			if (allow_excursions === 1) {
				icon.show();
				$.ajax({
					url    : Adzuki.base_uri + '/CruiseSheets/getShoreExcursionsByCruiseSheetId/' + cs_id,
					method : 'get',
					success: function success(response) {
						panel.append(response);
						icon.hide();
					}
				});
			}

			// if we wanted to show pricing in a modal.  not using for now
			// $('.per-person-pricing').click(function showPricingModal(e) {
			// 	var $self        = $(this),
			// 	    div_id       = $self.data('pricing-breakdown'),
			// 	    content      = $('#' + div_id).html(),
			// 	    title        = $self.data('cabin-title'),
			// 	    $modal       = $('.modal'),
			// 	    $modal_title = $modal.find('.modal-title'),
			// 	    $modal_body  = $modal.find('.modal-body');

			// 	e.preventDefault();

			// 	$modal_title.text(title);
			// 	$modal_body.html(content);

			// 	$modal.modal();
			// });

			panel.on('click', '.excursion-modal', function showModal(e) {
				var content = $(this).find(".content").html();
				var title   = $(this).data("title");
				var $modal = $('.modal');

				e.preventDefault();

				$modal.find('.modal-body').html(content);
				$modal.find('.modal-title').text(title);

				if (preview < 1) {
					$modal.modal();
				}
			});

			panel.on('click', '.port-link', function scrollTo(e) {
				var el = $(this).attr('href');

				e.preventDefault();

				if (preview < 1) {
					$('html, body').animate({
					    scrollTop: ($(el).offset().top)
					}, 500);
				}
			});

			panel.on('click', '.book-shore-excursion', function bookExcursion(e) {
				var $self = $(this),
				    href  = $self.attr('href');

				if (preview < 1) {
					window.open(href, 'st', 'height=600, width=1024, scrollbars=1');
				}

				e.preventDefault();
			});

			$('#ship').on('click', '.ship-link', function scrollTo(e) {
				var $self = $(this),
				    el    = '#' + $self.data('anchor');

				e.preventDefault();

				if (preview < 1) {
					$('html, body').animate({
					    scrollTop: ($(el).offset().top)
					}, 500);
				}
			});

			$sheet.on('click', '.per-person-modal', function showPricingModal(e) {
				var $self       = $(this),
				    $modal      = $('#modalWindow'),
				    $hidden_div = $($self.attr('href')),
				    $perperson  = $hidden_div.find('.perperson-breakdown'),
				    csp_id      = $self.data('csp-id'),
				    modal_title = $self.data('title'),
				    $modal_body = $modal.find('.modal-body');

				e.preventDefault();

				$modal.find('.modal-title').html(modal_title);
				$modal.modal('show');

				// indicates that we have perperson pricing cached already, so just show the modal
				if ($perperson.html().trim().length > 1) {
					$modal_body.html($hidden_div.html());

				// we do not have perperson cached already. make ajax call & API calls to get per person breakdown
				} else {
					$modal_body.html('<i class="' + Adzuki.FaIcon.getIconStyle('cog') + ' fa-spin fa-2x fa-fw"></i> Retrieving per person pricing...');

					$.ajax({
						url    : Adzuki.base_uri + '/CruiseSheets/perPersonPricing/' + csp_id,
						method : 'get',
						success: function success(response) {
							$perperson.html(response);
							$modal_body.html($hidden_div.html());
						},
						error: function error(response) {
							$perperson.html(response);
							$modal_body.html($hidden_div.html());
						}
					});
				}
			});

			if (preview > 0) {
				$('.page-header, .actions, .tab-pane').on('click', 'a', function anyClick(e) {
					Adzuki.StatusMessage('Error', 'Preview-mode only within CP Maxx. Open the cruise sheet in its own tab or window to be able to click on all links.');
					e.preventDefault();
				});
			}
		}, false);

		Adzuki.onload('/CruiseSheets/printCS', function printOnload() {
			window.print();
		}, false);
	});

	// when should the cruise sheet pricing expire?
	function getExpirationTime() {
		var utc_minus = moment().utc().subtract(expiration_seconds, 'seconds');

		return utc_minus;
	}

	// the time, in seconds, when the cruise sheet pricing was last retrieved and cached
	function getLastRefreshedMilliseconds()
	{
		var last_refreshed = $sheet.data('pricing-cache'),
		    utc_milli      = moment.utc(last_refreshed).valueOf();

		return utc_milli;
	}

	/**
	 * In cases where the cruise sheet is loaded in an iFrame, like in eRez, we are going to communicate back that after live pricing has been refreshed
	 * and ajaxed onto the cruise sheet.  Then eRez code will recognize this posted message and load the live pricing details in its interface.
	 *
	 */
	function postFinished()
	{
		window.parent.postMessage("finished", "*");

		$print_icon.removeClass('hidden');
	}

	// replace the inner HTML that shows the category's pricing info
	function replaceCategoryPricing(cruise_sheet_id, refreshed_categories)
	{
		var no_pricing_msg  = $('.sheets.cruise').data('pricing-unavailable');

		// loop through all of the categories on the page
		$cabins_pricing.each(function replaceCabinPricing(i) {
			var $self         = $(this),
			    category_code = $self.data('category-code'),
			    rate_option   = $self.data('rate-option');

			// cabin category code was not in the refreshed_categories for some reason, so show generic message
			if (refreshed_categories.indexOf(rate_option + '-' + category_code) < 0) {

				$self.html(no_pricing_msg);
				return;
			}

			// cabin category code was in refreshed_categories, which was returned by /CruiseSheets/refreshLivePricing/. render the pricing element
			$.ajax({
				url    : Adzuki.base_uri + '/CruiseSheets/renderPricing/' + cruise_sheet_id + '/' + category_code + '/' + rate_option,
				method : 'get',
				success: function success(raw_html) {
					$self.html(raw_html);
				},
				error: function error(response) {
					$self.html(no_pricing_msg);
				}
			});
		});

		postFinished();
	}

	// set pricing-cache data attribute to current date time
	function resetCacheDate()
	{
		$sheet.data("pricing-cache", new Date());
	}

	// show loading animation for each cabin category, then call script via ajax to refresh all pricing for the cruise sheet
	function retrievePricing(cs_id, show_loading)
	{
		var refreshed_categories = [];

		resetCacheDate();

		// do not want users attempting to print while live pricing is refreshing
		$print_icon.addClass('hidden');

		if (show_loading === true) {
			// show the loading animation for each cabin category. sometimes we don't need to show this, because it's already happening in the view based on php code
			$cabins_pricing.each(function replaceCabinPricing(i) {
				var $self = $(this);
				$self.html('<i class="' + Adzuki.FaIcon.getIconStyle('cog') + ' fa-spin fa-2x fa-fw"></i> Retrieving stateroom rates');
			});
		}

		$.ajax({
			// call Sabre
			url    : Adzuki.base_uri + '/CruiseSheets/refreshLivePricing/' + cs_id,
			method : 'get',
			success: function success(response) {
				$.each(response, function parseJson(sKey, sValue) {
					refreshed_categories.push(sKey);
				});

				replaceCategoryPricing(cs_id, refreshed_categories);
			},
			error: function error(response) {
				replaceCategoryPricing(cs_id, refreshed_categories);
			}
		});
	}

}(jQuery, window.Adzuki || {}));
